import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
import { OfferId, offers } from './offerData';
type Props = {
  selectedOffer: OfferId;
  className?: string;
};
export function PurchaseButton({
  selectedOffer,
  className = ''
}: Props) {
  const offer = offers[selectedOffer];
  return <CtaButton href={offer.checkoutUrl} className={className} data-id="element-30" data-mp="9925amdd89ga">
      Comprar {offer.shortName} · {offer.price}
      <ArrowUpRightIcon className="h-4 w-4" data-id="element-31" data-mp="3qpjxhp9mb972" />
    </CtaButton>;
}